import React, {useCallback, useEffect, useRef, useState} from 'react';
import CloseButton from "./CloseButton";

const ModalDiv = ({children, closeModal, style_}) => {

    const contentRef = useRef(null);
    const [shouldCentralize, setShouldCentralize] = useState(true);

    const handleKeyPress = useCallback((event) => {
        if (event.key === 'Escape') {
            closeModal();
        }
    }, []);

    useEffect(() => {
        const observer = new ResizeObserver(() => {
            if (contentRef.current) {
                const childWidth = contentRef.current.scrollWidth;
                const screenWidth = window.innerWidth;
                setShouldCentralize(childWidth < screenWidth);
            }
        });

        if (contentRef.current) observer.observe(contentRef.current);
        return () => observer.disconnect();
    }, []);

    useEffect(() => {
        document.addEventListener('keydown', handleKeyPress);

        return () => {
            document.removeEventListener('keydown', handleKeyPress);
        };
    }, [handleKeyPress]);

    return (
        <div className="overlay">
            <div className={shouldCentralize ? "centralized-modal-div-content" : "left-modal-div-content"}
                 style={style_}>
                <div ref={contentRef}>
                    <CloseButton onClose={closeModal}/>
                    <div style={{marginTop: '40px'}}>
                        {children}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ModalDiv;
